import { defineStore } from 'pinia';
import api from '@/api'; // Import api instance của bạn

export const useRbacStore = defineStore('rbac', {
  /**
   * State: Giống như 'data()' trong component.
   * Đây là nơi lưu trữ trạng thái.
   */
  state: () => ({
    loaded: false,
    permissions: new Set(), // Dùng Set để check quyền (has) cực nhanh
    apis: [],
  }),

  /**
   * Actions: Giống như 'methods' trong component.
   * Đây là nơi gọi API và thay đổi state.
   */
  actions: {
    /**
     * Tải quyền và API từ server, sau đó lưu vào state.
     * Hàm này sẽ được gọi sau khi đăng nhập hoặc khi tải lại trang.
     */
    async loadMe() {
      if (this.loaded) return; // Nếu đã tải rồi thì không tải lại

      try {
        const res = await api.get("/api/rbac-admin/me");
        const perms = res?.data?.data?.permissions || [];
        const apis = res?.data?.data?.apis || [];

        // Thay đổi state
        this.permissions = new Set(perms);
        this.apis = apis;
        this.loaded = true;
        
        // KHÔNG LƯU VÀO LOCALSTORAGE NỮA
        // localStorage.setItem(KEY_PERMS, JSON.stringify(perms));
        // localStorage.setItem(KEY_APIS, JSON.stringify(apis));

      } catch (error) {
        console.error("Lỗi khi tải RBAC:", error);
        this.clear(); // Xóa quyền nếu tải thất bại
      }
    },

    /**
     * Xóa state khi người dùng đăng xuất.
     */
    clear() {
      this.loaded = false;
      this.permissions = new Set();
      this.apis = [];
      
      // KHÔNG CẦN XÓA LOCALSTORAGE NỮA
    },

    /**
     * Các hàm helper (để thay thế cho các hàm cũ)
     * Giờ chúng là một phần của store.
     */
    hasPerm(code) {
      return this.permissions.has(code);
    },

    hasAll(arr = []) {
      return arr.every(c => this.permissions.has(c));
    },

    hasAny(arr = []) {
      return arr.some(c => this.permissions.has(c));
    },

    canApi(method, path) {
      if (!method || !path) return false;
      method = String(method).toUpperCase();
      return this.apis.some(a => a.method === method && a.path === path);
    }
  }
});